import { useCallback, useEffect, useState } from 'react';
import { courseCandidatesService, CourseCandidate } from '../../../../services/courseCandidatesService';

export function useCourses() {
  const [courses, setCourses] = useState<CourseCandidate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await courseCandidatesService.list();
      const visible = result.courses.filter((c) => c.status !== 'archived');
      visible.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
      setCourses(visible);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Failed to load courses';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { courses, loading, error, refresh };
}
